import React from 'react';
import { CreationForm } from './components/CreationForm';
import style from './Forms.module.scss';

export const Forms: React.FC = () => {
	return (
		<div className={style.container} data-test="Forms">
			<CreationForm />
		</div>
	);
};
